export const NAVGLOBAL_LINKS = [
  // NACC & the ADRCs
  {
    title: "NACC collaborations",
    url: "#",
    target: "",
    rel: "",
    class: "uk-parent",
    slug: "/nacc-collaborations",
    children: [
      {
        title: "About NACC",
        url: "/nacc-collaborations/about-nacc",
        class: "",
      },
      // {
      //   title: "Participant Diversity",
      //   url: "/nacc-collaborations/participant-diversity",
      //   class: "",
      // },
      // TODO: Delete this link and file once we are done with committees page for good.
      // {
      //   title: "Committees",
      //   url: "/nacc-collaborations/committees",
      //   class: "",
      // },
      {
        title: "NACC partnerships",
        url: "/nacc-collaborations/partnerships",
        class: "",
      },
      {
        title: "Additional data sets",
        url: "/nacc-collaborations/additional-data-sets",
        class: "",
      },
      {
        title: "Dementia Matters Podcast",
        url: "/nacc-collaborations/dm-pod-info",
        class: "",
      },
      {
        title: "UDSv4 Updates",
        url: "/nacc-collaborations/uds4-updates",
        class: "",
      },
      {
        title: "NACC Directory",
        url: "/nacc-collaborations/directory",
        class: "",
      },
      {
        title: "COVID-19",
        url: "/nacc-collaborations/covid-19",
        class: "",
      },
      {
        title: "SCAN",
        url: "https://scan.naccdata.org/",
        class: "",
      },
      {
        title: "Digital Pilot Program",
        url: "/nacc-collaborations/digital-biomarker-pilots",
        class: "",
      },
      {
        title: "CLARiTI",
        url: "/nacc-collaborations/clariti",
        class: "",
      },
    ],
  },

  // Access data
  {
    title: "Access data",
    url: "#",
    target: "",
    rel: "",
    class: "uk-parent",
    slug: "/requesting-data",
    children: [
      {
        title: "About NACC data",
        url: "/requesting-data/nacc-data",
        class: "",
      },
      {
        title: "The data request process",
        url: "/requesting-data/data-request-process",
        class: "",
      },
      {
        title: "Query system",
        url: "/requesting-data/web-query",
        class: "",
      },
      {
        title: "MRI preview system",
        url: "/requesting-data/mri-previews",
        class: "",
      },
      {
        title: "Submit data request",
        url: "/requesting-data/submit-data-request",
        class: "",
      },
      {
        title: "Biospecimen locator",
        url: "/requesting-data/biospecimen-locator",
        class: "",
      },
      {
        title: "Data Front Door",
        url: "/data-front-door",
        class: "",
      },
    ],
  },

  // Data Analysis resources
  {
    title: "Data Analysis",
    url: "#",
    target: "",
    rel: "",
    class: "uk-parent",
    slug: "/data-analysis",
    children: [
      {
        title: "Data File FAQ",
        url: "/data-analysis/faq",
        class: "",
      },
    ],
  },

  // Publish your project
  {
    title: "Publishing",
    url: "#",
    target: "",
    rel: "",
    class: "uk-parent",
    slug: "/publish-project",
    children: [
      {
        title: "Checklist for authors",
        url: "/publish-project/authors-checklist",
        class: "",
      },
      {
        title: "Submit your manuscript or abstract",
        url: "/publish-project/submit-manuscript",
        class: "",
      },
      {
        title: "Resources for PMC submission",
        url: "/publish-project/pmc-resources",
        class: "",
      },
    ],
  },

  // NACC Productivity
  {
    title: "NACC productivity",
    url: "#",
    target: "",
    rel: "",
    class: "uk-parent",
    slug: "/nacc-productivity",
    children: [
      {
        title: "Publications using UDS",
        url: "/nacc-productivity/publications",
        class: "",
      },
      {
        title: "NACC-funded research",
        url: "/nacc-productivity/nacc-funded-research",
        class: "",
      },
      {
        title: "New Investigator Awards",
        url: "/nacc-productivity/new-investigator-awards",
        class: "",
      },
      // {
      //   title: "Research Highlights",
      //   url: "/nacc-productivity/research-highlights",
      //   class: "",
      // },
      {
        title: "Call for Papers",
        url: "/nacc-productivity/call-for-papers",
        class: "",
      },
    ],
  },

  // Data collection
  {
    title: "Data collection",
    url: "#",
    target: "",
    rel: "",
    class: "uk-parent",
    slug: "/data-collection",
    children: [
      {
        title: "Forms & documentation",
        url: "/data-collection/forms-documentation/uds-4",
        class: "",
      },
      {
        title: "Clinical training",
        url: "/data-collection/training",
        class: "",
      },
      {
        title: "Calculators",
        url: "/data-collection/tools-calculators/cdr",
        class: "",
      },
      {
        title: "Data submission overview",
        url: "/data-collection/data-submission",
        class: "",
      },
      {
        title: "Mixed Protocol Image Submission",
        url: "/data-collection/mixed-protocol-image-submission",
        class: "",
      },
      {
        title: "Electronic Data Capture",
        url: "/edc",
        class: "",
      },
      {
        title: "NACCID Assignment Process",
        url: "/data-collection/naccid",
        class: "",
      },
      {
        title: "UDSv4 Pilot Program",
        url: "/data-collection/udsv4-pilot",
        class: "",
      },
    ],
  },

  // ADRC resources
  {
    title: "ADRC resources",
    url: "#",
    target: "",
    rel: "",
    class: "uk-parent",
    slug: "/adrc-resources",
    children: [
      {
        title: "ADRC meetings & presentations",
        url: "/adrc-resources/meeting-presentations",
        class: "",
      },
      {
        title: "About The NACC Data Platform",
        url: "/adrc-resources/nacc-data-platform",
        class: "",
      },

      {
        title: "Data Management and Sharing Guidance",
        url: "/adrc-resources/data-management-sharing-guidance",
        class: "",
      },
      {
        title: "Best practices",
        url: "/adrc-resources/best-practices",
        class: "",
      },
      {
        title: "Progress reports to NIA",
        url: "/adrc-resources/progress-reports",
        class: "",
      },
      {
        title: "REDCap documentation",
        url: "/adrc-resources/redcap",
        class: "",
      },
      {
        title: "ADRC webinars",
        url: "/adrc-resources/adrc-webinars",
        class: "",
      },
      {
        title: "Listservs",
        url: "/adrc-resources/collaboration",
        class: "",
      },
      {
        title: "REC Webpage",
        url: "/adrc-resources/rec-home",
        class: "",
      },
      {
        title: "UDSv4 Digital Voice",
        url: "/adrc-resources/udsv4-digital-voice",
        class: "",
      },
      {
        title: "ADRC Community Forum",
        url: "/adrc-resources/community-forum",
        class: "",
      },
    ],
  },
];
